import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Alert from "@mui/material/Alert";
import {
     factTableGetJsonSchemaRequest,
     factTableAddTableRecordRequest,
} from "../../../../_redux/_actions";
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";

export default function AddRecordDataModal(props) {
     const [jsonData, setJsonData] = useState({ key: "value" });
     const [state, dispatch] = useContext(Context);

     const stringRef = useRef("");

     const actionDispatch = useDispatch();

     useEffect(() => {
          actionDispatch(
               factTableGetJsonSchemaRequest({ factTableId: props.factableId }),
          );
     }, []);

     const { manageList } = useSelector((state) => {
          return {
               manageList: state.factTable.dataSchema,
          };
     });

     const addDataRecord = () => {
          actionDispatch(
               factTableAddTableRecordRequest({
                    factTableId: props.factableId,
                    jsonObjectString: stringRef.current,
                    closeModal: handleCloseAddRecord,
                    getManageDataList: props.getManageDataList,
               }),
          );
     };

     const handleCloseAddRecord = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: false,
               },
          });
     };

     return (
          <>
               <div className="sba-add-record-data-wr">
                    <div className="sba-upload-json-view">
                         <JsonView
                              src={manageList}
                              editable={{
                                   delete: false,
                                   edit: true,
                              }}
                              onEdit={(params) => {
                                   stringRef.current = JSON.stringify(
                                        params.src,
                                   );
                              }}
                         />

                         {/* <Alert severity="error" sx={{ mt: 1 }}>
                              Date error Alert.
                         </Alert> */}
                    </div>
                    <div className="sba-add-record-data-wr__save">
                         <UiButton
                              onClick={addDataRecord}
                              name="Save"
                              variant="contained"
                         />
                    </div>
               </div>
          </>
     );
}
